import React from 'react'
import Slider from '../components/slider.jsx';
import Cards from '../components/cards.jsx';

const home = () => {
  return (
    <div>
    <Slider/>
    <Cards/>
    </div>
  )
}

export default home